import config from 'config';

export const SyncAccount = function (): void {
  // If a window does not have a parent, its parent property is a reference to itself. (https://developer.mozilla.org/en-US/docs/Web/API/Window/parent)
  // Only call when CPA is embedded in commerce to sync the updated data on commerce's side
  if (window.parent && window.parent !== window) {
    window.parent.postMessage('syncAccount', (config.COMMERCE_URL as string).replace('/{lang}/', ''));
  }
};
